import { makeStyles, Text } from '@rneui/themed'
import { User } from '@nextforce/api'
import React, { FunctionComponent } from 'react'

interface Props {
  approver?: User
}

export const ShiftApproverView: FunctionComponent<Props> = props => {
  const styles = useStyles()

  if (props.approver) {
    return (
      <Text style={styles.container}>
        Shift Manager: {props.approver.firstName} {props.approver.lastName}
      </Text>
    )
  }
  return null
}

const useStyles = makeStyles(theme => ({
  container: {
    fontSize: 13,
    color: theme.colors?.grey1,
    textAlign: 'left',
  },
}))
